import PrivacyPolicy from '@/components/PrivacyPolicy.vue';

const routes =

  {
    path: '/privacy_policy',
    component: PrivacyPolicy,
    name: 'PrivacyPolicy',
    meta:{
      requiredAuth: false
    }
  }

export default routes;
